import { CSSProperties, ReactElement, useState } from "react";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse, ListItemButton } from "@mui/material";
import { ICatalogCategory, ITreeCatalogCategory } from "../../types";
import { IContentAreaProps } from "../../../../types";

interface IProps extends IContentAreaProps {
  wasEdited: boolean;
  tree: ITreeCatalogCategory[];
  category: ICatalogCategory | null;
  setCategory: (category: ITreeCatalogCategory, canDelete: boolean) => void;
}


interface ITreeNodeProps  {
  wasEdited: boolean;
  node: ITreeCatalogCategory;
  selected: ICatalogCategory | null;
  setCategory: (category: ITreeCatalogCategory, canDelete: boolean) => void;
}

const styles: Record<string, CSSProperties> = {
  nested0: {
    paddingLeft: "1em"
  },
  nested1: {
    paddingLeft: "2em"
  },
  nested2: {
    paddingLeft: "3em"
  },
  nested3: {
    paddingLeft: "4em"
  }
};

const TreeNode = ({ node, selected, setCategory, wasEdited }: ITreeNodeProps): ReactElement => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if(!wasEdited) {
      setCategory(node, node.children.length === 0);
    }
  };

  const hasChildren = node.category.depth < 2 && node.children && node.children.length > 0;

  return(
    <>
      <ListItemButton
        style={styles[`nested${node.category.depth}`]}
        selected={selected?.categoryID === node.category.categoryID}
        onClick={handleClick}>
        <ListItemText primary={node.category.name}  />
        { hasChildren && open && <ExpandLess onClick={() => setOpen(!open)} />}
        { hasChildren && !open &&  <ExpandMore onClick={() => setOpen(!open)} />}
      </ListItemButton>
      { node.children &&
        <Collapse in={open} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            { node.children.map((n) =>
              <TreeNode key={`node-child-${node.category.depth}-${n.category.categoryID}`} node={n} selected={selected} setCategory={setCategory} wasEdited={wasEdited}/>
            )
            }
          </List>
        </Collapse>
      }
    </>
  );
};


const CategoryTreeView = ({ tree, category, setCategory, wasEdited, parentSize }: IProps): ReactElement => {


  return(
    <div style={{ overflowY: "auto", marginTop: ".5em", alignSelf: "stretch", height: parentSize.height - 222 }}>
      <List>
        { tree.map((node) => {
          return(
            <TreeNode key={`cat-node-${node.category.categoryID}`} node={node} selected={category}
              setCategory={setCategory} wasEdited={wasEdited} />
          );
        })

        }
      </List>
    </div>
  );
};

export default CategoryTreeView;
